var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"infoCardTreeMap"}},[_c('h4',{staticClass:"gray-font-title",staticStyle:{"padding":"0","margin":"0"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('TreeMap',{attrs:{"data":_vm.data_chart,"height":'100%',"width":'100%'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }